import angular from "angular";

angular
    .module('app')
    .component('permissionsControl', {
        template: require('./permissions-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            modules: '<'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;


    $ctrl.$onInit = function () {

    };


    $ctrl.openModuleForm = function (module) {

        $uibModal
            .open({
                component: 'moduleForm',
                resolve: {
                    module: function () {
                        return module;
                    }
                }
            })
            .result
            .then(
                function (result) {



                    if (module) {
                        module.name = result.name;
                        module.label = result.label;
                        module.type = result.type;
                    } else
                        result.permissions = [];
                        $ctrl.modules.push(result);
                }
            );
    };

    $ctrl.openPermissionForm = function (module, permission) {

        $uibModal
            .open({
                component: 'permissionForm',
                resolve: {
                    module: function () {
                        return module;
                    },

                    modules: function () {
                        return $ctrl.modules;
                    },

                    permission: function () {
                        return permission;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (permission) {
                        permission.name = result.name;
                        permission.label = result.label;
                        permission.module_id = module.id;

                    } else {


                        module.permissions.push(result)
                    }
                },
                function () {

                }
            );
    };


    $ctrl.deleteModule = function (module, index) {

        if (module.deleteLoading) {
            return;
        }

        if (!confirm(` Удалить ${module.label} ?`)) {
            return;
        }

        module.deleteLoading = true;

        $http.delete(`/admin/modules/${module.id}`).then(
            function (response) {
                $ctrl.modules.splice(index, 1);
                Notifier.success('Модуль успешно удален', 2);
            },
            function () {
                module.deleteLoading = false;
                Notifier.error('Произошла ошибка', 2);
            }
        );
    };

    $ctrl.deletePermission = function (module,permission, index) {

        if (permission.deleteLoading) {
            return;
        }

        if (!confirm(` Удалить ${permission.label} ?`)) {
            return;
        }

        permission.deleteLoading = true;

        $http.delete(`/admin/permissions/${permission.id}`).then(

            function (response) {
                module.permissions.splice(index, 1);
                Notifier.success('Разрешение успешно удалена', 2);
            },

            function () {
                permission.deleteLoading = false;
                Notifier.error('Произошла ошибка', 2);
            }
        );

    }


}
